/**
 * Layout shell for Delivery Configuration admin pages.
 *
 * Renders section header, horizontal tabs for sub-routes, and an outlet for child routes.
 */
import { useMemo } from "react";
import { Outlet } from "react-router-dom";
import SingleTab from "../../../../components/singleTab/singleTab";

/**
 * Delivery Configuration layout with tab navigation and nested route outlet.
 *
 * @returns Layout wrapping delivery configuration child routes
 */
const DeliveryConfigurationLayout = () => {
  const tabs = useMemo(() => {
    return [
      { id: "track-status", label: "Track Status" },
      { id: "text-notes", label: "Text Notes" },
      { id: "letter-upload", label: "Letter Upload" },
      { id: "sftp-push", label: "SFTP Push" },
    ];
  }, []);

  return (
    <div className="delivery-configuration-layout flex h-full flex-col overflow-hidden">
      <div className="delivery-configuration-layout__header text-h11 font-semibold">
        Delivery Config
      </div>
      <div className="delivery-configuration-layout__tabs mb-2 flex flex-row border-b border-primaryGray-16">
        {tabs.map((tab) => (
          <SingleTab key={tab.id} id={tab.id} label={tab.label} />
        ))}
      </div>
      <div className="delivery-configuration-layout__content flex-1 overflow-hidden">
        <Outlet />
      </div>
    </div>
  );
};

export default DeliveryConfigurationLayout;
